import { generateGuest, getGuestData } from './auth/generateGuest';
import cfac22 from '../cfac22';

let guestCreationInFlight = null;

export default function createGuest() {
  if (guestCreationInFlight) return guestCreationInFlight;

  const storedGuestData = getGuestData();

  if (storedGuestData?.guestId && storedGuestData?.guestToken) {
    return Promise.resolve(storedGuestData);
  }

  guestCreationInFlight = (async () => {
    const response = await generateGuest({ partnerId: cfac22('partnerId') });
    return response.success ? response.data : null;
  })();

  guestCreationInFlight.then(
    () => {
      guestCreationInFlight = null;
    },
    () => {
      guestCreationInFlight = null;
    }
  );

  return guestCreationInFlight;
}
